import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function PaymentSuccessPayU() {
    return (
        <div className="payment-container">
            <div className="payment-card">
                {/* Success Icon */}
                <div className="success-icon">
                    <svg
                        className="checkmark"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 52 52"
                    >
                        <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                        <path className="checkmark-check" fill="none" d="M14 27l7 7 16-16" />
                    </svg>
                </div>

                {/* Title */}
                <h1>Payment Successful 🎉</h1>
                <p>
                    Your order has been accepted.
                </p>

                {/* Order Details */}
                <div className="order-details">
                    <p style={{ whiteSpace: "wrap", textAlign: "center" }}><strong>Order ID:</strong> {window.location.href?.split('/')?.[4] || "N/A"}</p>
                    {/* <p><strong>Amount Paid:</strong> ₹10</p> */}
                    {/* <p><strong>Payment Method:</strong> Cashfree</p> */}
                </div>

                {/* Actions */}
                {/* <div className="actions">
                    <button className="btn btn-primary">Download Receipt</button>
                    <button className="btn btn-secondary">Continue Shopping</button>
                </div> */}
            </div>
        </div>
    )
}
